import { DownloadIcon, MenuBookIcon, QuestionAnswerIcon, SeminarIcon, } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { caseListPath, columnListPath, documentListPath, seminarListPath, } from '@/utils/router/links';
/** 記事リンク: 選定支援事例 */
export const ARTICLE_PAGE_LINK_CASE = {
    icon: QuestionAnswerIcon,
    text: '選定支援事例',
    to: caseListPath(),
    type: 'case',
};
/** 記事リンク: DL資料 */
export const ARTICLE_PAGE_LINK_DOCUMENT = {
    icon: DownloadIcon,
    text: 'ダウンロード資料',
    to: documentListPath(),
    type: 'document',
};
/** 記事のリンク: コラム */
export const ARTICLE_PAGE_LINK_COLUMN = {
    icon: MenuBookIcon,
    text: 'コラム',
    to: columnListPath(),
    type: 'column',
};
/** 記事のリンク: セミナー */
export const ARTICLE_PAGE_LINK_SEMINAR = {
    icon: SeminarIcon,
    text: 'セミナー',
    to: seminarListPath(),
    type: 'seminar',
};
